import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const Spinner = ({ size = 24 }) => {
  return (
    <Spin
      indicator={<LoadingOutlined style={{ fontSize: size }} spin />}
      data-testid="loadingIndicator"
    />
  );
};

export default Spinner;
